
import elementIds from '@/const/elementIds.json';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'SettingsPortInput',

  props: {
    inputFor: {
      type: String,
      default: 'coordinator-port-input',
    },
    errorMessage: {
      type: String,
    },
    fieldName: {
      type: String,
      required: true,
    },
    value: {
      required: true,
    },
    loading: {
      type: Boolean,
    },
    isPortValid: {
      default: null,
    },
    handleChange: {
      type: Function,
    },
  },
  emits: ['update:modelValue'],
  setup() {
    return { elementIds };
  },

  computed: {
    port: {
      get(): any {
        return this.value;
      },
      set(val: any) {
        if (this.handleChange) this.handleChange(val, this.fieldName);
        this.$emit('update:modelValue', +val);
      },
    },
  },
});
